module.exports = __webpack_public_path__ + "img/jsimg.ce40066a.png";